<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">Farrar, Straus and Giroux<br/>19 Union Square West, New York 10003</p>
<p class="crt">Copyright © 2006 by Tom Lutz<br/>All rights reserved<br/>Distributed in Canada by Douglas &amp; McIntyre Ltd.<br/>Printed in the United States of America<br/>Published in 2006 by Farrar, Straus and Giroux<br/>First paperback edition, 2007</p>
<p class="crt1">The Library of Congress has cataloged the hardcover edition as follows:<br/>              Lutz, Tom.<br/>                     Doing nothing : a history of loafers, loungers, slackers and bums in<br/>                 America / Tom Lutz.— 1st ed.<br/>                        p. cm.<br/>                     Includes bibliographical references.<br/>                     ISBN-13: 978-0-86547-650-9 (hardcover : alk. paper)<br/>                     ISBN-10: 0-86547-650-0 (hardcover : alk. paper)<br/>                     1. Slackers—United States—History. 2. Laziness—United States—<br/>                 History. I. Title.<br/>                 BJ1498.L88 2006<br/>                 174—dc22</p>
<p class="crt2">2005027230</p>
<p class="crt">Paperback ISBN-13: 978-0-86547-737-7<br/>Paperback ISBN-10: 0-86547-737-X</p>
<p class="crt">Designed by Debbie Glasserman</p>
<p class="crt"><a class="pubhlink" href="http://www.fsgbooks.com" target="_blank">www.fsgbooks.com</a></p>
<p class="crt">1   3   5   7   9   10   8   6   4   2</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780865477377_epub_cop_r1.vue?f78b1326